import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: {
    flex: 1,
  },
  card: {
    alignItems: 'center',
    justifyContent: 'center',
    height: 80,
    width: 100,
    borderWidth: 1,
    borderBottomWidth: 0,
    borderLeftWidth: 0,
  },
});
